// Default column visibility for the Table view, shared by the page-level column
// chooser and the TableView component so they start from the same set.
export const DEFAULT_TABLE_COLUMNS = {
  actions: true,
  assignee: true,
  task: true,
  notes: false,
  category: true,
  task_class: true,
  status: true,
  do_date: true,
  created_at: false,
  updated_at: false,
  read: false,
  is_archived: false,
  reviewer: true,
  line_up: true,
  project: true,
  epic: true,
  primary_epic: false,
  track: true,
  sprint: true,
  sprint_track_name: false,
  estimated_time: true,
  total_time_taken: true,
  action_items_count: false,
  completed_action_items_count: false,
  ai_progress: false,
};
